<template>
  <footer class="light-footer">
    <div class="container">
      <div class="row mb-5">
        <div class="col">
          <a target="_blank" href="https://www.wirecard.com" class="footer-logo">
            <img src="../assets/logo.png" width="148">
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 mb-5 mb-md-0">
          <h5>{{ $t('footer.aboutTitle') }}</h5>
          <p>{{ $t('footer.aboutDescription') }}</p>
          <a href="https://www.wirecard.com/contact/sales/" class="btn btn-red btn-arrow"><span>{{ $t('footer.aboutButton') }}</span></a>
        </div>
        <div class="col-md-3 mb-5 mb-md-0">
          <ul class="footer-list">
            <li><a target="_blank" href="https://www.wirecard.com/company">{{ $t('footer.menu.company') }}</a></li>
            <li><a target="_blank" href="https://www.wirecard.com/benefits">{{ $t('footer.menu.benefits') }}</a></li>
            <li><a target="_blank" href="https://www.wirecard.com/products">{{ $t('footer.menu.products') }}</a></li>
            <li><a target="_blank" href="https://www.wirecard.com/market-intelligence">Market Intelligence</a></li>
            <li><a target="_blank" href="https://ir.wirecard.com/websites/wc/german/500/ueberblick.html">Investor Relations</a></li>
            <li><a target="_blank" href="https://www.wirecard.com/newsroom">Newsroom</a></li>
            <li><a target="_blank" href="https://www.wirecard.com/careers">{{ $t('footer.menu.careers') }}</a></li>
          </ul>
        </div>
        <div class="col-md-4">
          <div class="footer-newsletter mb-5">
            <p>{{ $t('footer.newsletter.title') }}</p>
            <form id="subscribe_93_" action="https://login.mailingwork.de/optin/optin/execute" method="post" accept-charset="utf-8">
              <fieldset>

                <input type="hidden" name="account_id" value="2727">
                <input type="hidden" name="account_code" value="xnfX4">
                <input type="hidden" name="optinsetup_id" value="93">
                <input type="hidden" name="optinsetup_code" value="yQrhZ">
                <input type="hidden" id="subscribe_93_mwic" name="ic" value="0">

                <input type="email" v-bind:placeholder="$t('footer.newsletter.input')" id="subscribe_93_optin_field_10" name="fields[10]" required>
                <div class="form-group form-group-checkbox">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" required name="privacy" value="Yes" class="custom-control-input" id="form-input-privacy">
                    <i18n path="footer.newsletter.terms" tag="label" class="custom-control-label" for="form-input-privacy">
                      <a href="https://www.wirecard.com/privacy-policy/" target="_blank">{{ $t('footer.newsletter.pp') }}</a>
                    </i18n>
                  </div>
                </div>
                <button type="submit">Submit</button>
              </fieldset>
            </form>
          </div>
          <ul class="footer-list text-left text-md-right">
            <li><a target="_blank" href="https://wirecard.com/innovation-labs/" class="font_label_bold">Wirecard Labs</a></li>
          </ul>
        </div>
      </div>
      <div class="row align-items-end pt-4">
        <div class="col-12 col-lg-4">
          <div class="footer-social clearfix">
            <p class="mb-0">Follow Us</p>
            <ul class="clearfix">
              <li>
                <a target="_blank" href="https://blog.wirecard.com/">
                  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" class="inline-svg">
                    <path d="M11.165 3.91196L9.32276 10.6796H9.28835L7.65667 3.91196H5.63984L3.93933 10.6796H3.90289L2.13253 3.91196H0.010437L2.8178 12.9773H4.92218L6.58524 6.24105H6.62067L8.30752 12.9773H10.3572L13.199 3.91196H11.1655" fill="#A2AAAD"></path>
                    <path d="M11.1604 0.455261H13.198V2.45437H11.1604V0.455261Z" fill="#A2AAAD"></path>
                  </svg>
                </a>
              </li>
              <li><a target="_blank" href="https://twitter.com/wirecard"><font-awesome-icon :icon="['fab', 'twitter']" /></a></li>
              <li><a target="_blank" href="https://www.facebook.com/wirecardgroup/"><font-awesome-icon :icon="['fab', 'facebook']" /></a></li>
              <li><a target="_blank" href="https://de.linkedin.com/company/39936"><font-awesome-icon :icon="['fab', 'linkedin']" /></a></li>
              <li><a target="_blank" href="https://de.linkedin.com/company/39936"><font-awesome-icon :icon="['fab', 'xing']" /></a></li>
              <li><a target="_blank" href="https://www.youtube.com/user/WirecardGroup"><font-awesome-icon :icon="['fab', 'youtube']" /></a></li>
              <li><a target="_blank" href="https://plus.google.com/103868872911768435991"><font-awesome-icon :icon="['fab', 'google-plus-g']" /></a></li>
              <li><a target="_blank" href="https://www.wirecard.de/newsroom/rss/"><font-awesome-icon icon="rss" /></a></li>
            </ul>
          </div>
        </div>
        <div class="col-8 col-lg-6">
          <p class="footer-contact">
            <a target="_blank" href="https://www.wirecard.com/">wirecard.com</a>
            <a href="mailto:contact@wirecard.com">contact@wirecard.com</a>
            <a href="tel:+4908944241400">+49 (0) 89 44 24 - 14 00</a>
          </p>
        </div>
        <div class="col-4 col-lg-2">
          <!-- <locale-switch></locale-switch> -->
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container text-center">
        <ul class="component-footernav">
          <li><a href="https://www.wirecard.com/imprint/">{{ $t('footer.subMenu.legal') }}</a></li>
          <li><a href="https://www.wirecard.com/privacy-policy/">{{ $t('footer.subMenu.privacy') }}</a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import LocaleSwitch from './LocaleSwitch.vue'
import axios from 'axios'

const optin_context_subscribe_93_ = {
  
  form_id: 'subscribe_93_',
  ci_id: 'subscribe_93_mwic',
  ci: true,
  check_lists_or_setups: false,
  mandatories: [ ],
  emailfields: ["subscribe_93_optin_field_10"],
  subscriberlists: [ ],
  optinsetups: [ ],
  datepicks: [ ],
  msg: {
    "error_mandatory":"Füllen Sie alle mit einem * markierten Felder aus!",
    "error_email":"Bitte überprüfen Sie Ihre E-Mail-Adresse!",
    "error_list":"Bitte wählen Sie mindestens eine Liste!"
  },

  init: function () {
    for (let i = 0; i < this.datepicks.length; i++) {
      var DTP = new DateTimePicker( this.datepicks[i].id + '_hidden',this.datepicks[i].id,this.datepicks[i]);
      DTP.init();
    }
      
    if (this.ci) {
      setInterval(function(){
        var el = document.getElementById(optin_context_subscribe_93_.ci_id);
        if (el) {
          if (isNaN(parseInt(el.value)) == true){
            el.value = 0;
          } else {
            el.value = parseInt(el.value) + 17;
          }
        }
      }, 1000);
    }
  },

  checkForm: function() {
    try {
      var frmelem = document.getElementById(this.form_id);
      if (this.check_lists_or_setups) {
        var temp = false;
        for (var i=0; i < this.subscriberlists.length;i++) {
          if (document.getElementById(this.subscriberlists[i]).checked==true) {
            temp = true;
            break;
          }
        }
          
        for (let i = 0; i < this.optinsetups.length; i++) {
          if (document.getElementById(this.optinsetups[i]).checked==true) {
            temp = true;
            break;
          }
        }
            
        if (!temp) throw this.msg.error_list;
      }
          

      for (let i = 0; i < this.mandatories.length; i++) {
        const cfObj = document.getElementById(this.mandatories[i]);
          
        if (cfObj != null) {
          if (cfObj.type.toLowerCase()=="text" || cfObj.type.toLowerCase() == "textarea") {
            if (cfObj.value.match(/^\s*$/)) throw this.msg.error_mandatory;
          } else if (cfObj.type.toLowerCase() == "radio" || cfObj.type.toLowerCase() == "checkbox") {
            var tmpObj=document.getElementsByName(cfObj.name);
            var tmpCheck = false;

            for (let j = 0; j < tmpObj.length; j++) {
              if (tmpObj[j].checked == true) {
                tmpCheck = true;
                break;
              }
            }

            if (!tmpCheck) throw this.msg.error_mandatory;
          } else if (cfObj.type.toLowerCase().indexOf("select") >= 0) {
            if (cfObj.selectedIndex<=0) throw this.msg.error_mandatory;
            if (cfObj.selectedIndex<=0) throw this.msg.error_mandatory;
          }
        }
      }

      var validmail = new RegExp("^[a-zA-Z0-9_\\.\\-]+@[a-zA-Z0-9_\\.\\-]+\\.[a-zA-Z0-9]{2,13}$");
        
      for (let i = 0; i < this.emailfields.length; i++) {
        if (!validmail.test(document.getElementById(this.emailfields[i]).value)) throw this.msg.error_email;
      }

      // const formData = new FormData()
      // formData.append('account_id', '2727')
      // formData.append('account_code', 'xnfX4')
      // formData.append('optinsetup_id', '93')
      // formData.append('optinsetup_code', 'yQrhZ')
      // formData.append('ic', document.getElementById(optin_context_subscribe_93_.ci_id).value)
      // formData.append('fields[10]', document.getElementById(this.emailfields[0]).value)

      // axios({
      //   method: 'post',
      //   url: 'https://login.mailingwork.de/optin/optin/execute',
      //   data: formData,
      //   config: {
      //     headers: {
      //       'Content-Type': 'multipart/form-data'
      //       }
      //     }
      //   }).then(function (response) {
      //       //handle success
      //       console.log(response);
      //   }).catch(function (response) {
      //       //handle error
      //       console.log(response);
      //   });

      frmelem.submit();
    } catch (e) {
      console.log(e);
      return false;
    }
  }
}

export default {
  name: 'Footer',
  components: {
    'locale-switch': LocaleSwitch
  },
  computed: {
    ...mapFields({
      wirecardFooter: 'ui.footer'
    }),
  },
  // methods: {
  //   submitForm() {
  //     optin_context_subscribe_93_.checkForm()
  //   }
  // },
  mounted() {
    optin_context_subscribe_93_.init()
  }
};
</script>
